<template>
  <Modal v-model="state" :title="plustitle" width="600" class-name="c-docs vertical-center-modal" :mask-closable="false">
    <div class="m-form ghost-button-styles">
      <el-form :model="landData" ref="configForm" label-width="150px" label-position="right" :rules="configRules">
        <el-form-item label="选择游戏" prop="gameId">
          <el-select v-model="landData.gameId" placeholder="全部" filterable :popper-append-to-body="false">
            <el-option v-for="item in gameData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="媒体">
          <el-radio-group :disabled="edit" v-model="landData.mediaId" size="small">
            <el-radio-button
              ghost
              v-for="item in [
                { mediaName: '巨量引擎', mediaId: 10 },
                { mediaName: '腾讯', mediaId: 16 },
                { mediaName: '磁力引擎', mediaId: 32 }
              ]"
              :key="item.mediaId"
              :label="item.mediaId"
            >
              {{ item.mediaName }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="账号类型" v-if="[10].includes(landData.mediaId)">
          <el-radio-group v-model="landData.acType" size="small">
            <el-radio-button ghost v-for="item in acTypes[landData.mediaId]" :key="item.key" :label="item.key">
              {{ item.name }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="分包账号ID/组织ID" prop="acId">
          <el-input v-model="landData.acId" placeholder="分包账号ID/组织ID" />
        </el-form-item>
        <el-form-item label="分包应用ID" prop="appId">
          <el-input v-model="landData.appId" placeholder="分包应用ID" />
        </el-form-item>

        <el-form-item label="母包包体ID" v-if="landData.mediaId === 32" prop="packageId">
          <el-input v-model="landData.packageId" placeholder="快手应用详细应用包名后面括号里的ID" />
        </el-form-item>

        <el-form-item label="分包池数量" prop="poolSize">
          <el-input v-model="landData.poolSize" placeholder="分包池数量" />
        </el-form-item>
        <el-form-item label="分包池触发创建比例" prop="freeSpace">
          <el-input v-model="landData.freeSpace" placeholder="分包池触发创建比例">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>

        <el-form-item label="预警提醒">
          <el-switch v-model="landData.notice"></el-switch>
          <span class="tips" style="font-size: 12px; color: red; margin-left: 10px">当可用分包数量不足或者分包账号异常时提醒</span>
        </el-form-item>

        <el-form-item label="提醒人" v-if="landData.notice">
          <el-select v-model="landData.warnRemindOps" style="width: 320px" :popper-append-to-body="false" multiple filterable clearable>
            <el-option v-for="item in SYS_USERS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>

    <template slot="footer">
      <div class="m-foot">
        <Button @click="$emit('input', false)">取消</Button>
        <Button type="primary" :loading="loading" @click="save">
          <span v-if="loading">提交中...</span>
          <span v-else>确认</span>
        </Button>
      </div>
    </template>
  </Modal>
</template>
<script>
import { initPageData, SYS_USERS } from '@/data/global-opts'
const PAGE_REQUIRED_OPTS = initPageData([SYS_USERS])

export default {
  name: 'toutiaoGameConfigSet',
  props: {
    value: {
      type: Boolean
    },
    title: {
      type: String
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    info: {
      type: Object
    },
    edit: {
      type: Boolean,
      default() {
        return false
      }
    },
    gameData: {
      type: Array,
      require: true
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    plustitle() {
      return `${this.edit ? '修改' : '新增'}${this.title}`
    }
  },
  watch: {
    info: {
      handler() {
        this.updateInfo()
      },
      deep: true
    }
  },
  methods: {
    updateInfo() {
      const info = JSON.parse(JSON.stringify(this.info))
      this.landData = info
    },
    // 提交验证
    save() {
      this.$refs.configForm.validate((valid) => {
        if (valid) {
          this.$emit('on-save', this.landData)
        }
      })
    }
  },

  data() {
    return {
      landData: {},
      acTypes: {
        10: [
          { key: 'AD', name: '计划主账号' },
          { key: 'BP', name: '巨量纵横组织' }
        ]
      },
      configRules: {
        gameId: [{ required: true, message: '请选择游戏', trigger: 'change' }],
        acId: [
          { required: true, message: '请输入（分包账号ID/组织ID）', trigger: 'blur' },
          { pattern: /^[0-9]+$/, message: '（分包账号ID/组织ID）必须为数字值', trigger: 'blur' }
        ],
        appId: [
          { required: true, message: '请输入应用ID', trigger: 'blur' },
          { pattern: /^[0-9]+$/, message: '应用ID必须为数字值', trigger: 'blur' }
        ],
        poolSize: [
          { required: true, message: '请输入分包池大小', trigger: 'blur' },
          { pattern: /^(?:[1-9]\d{0,2}|1000|0)$/, message: '分包池大小范围0-1000', trigger: 'blur' }
        ],
        freeSpace: [
          { required: true, message: '请输入分包池触发创建比例', trigger: 'blur' },
          { pattern: /^(?:[1-9][0-9]?|100)$/, message: '分包池触发创建比例创建比例范围0-100', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.updateInfo()
  }
}
</script>
<style lang="scss" scoped>
.c-docs {
  position: relative;

  .m-form {
    padding-top: 20px;
  }
}

::v-deep .ivu-modal {
  min-width: 600px;
}
</style>
